import imageCompression from 'browser-image-compression';

export const validateImageUrl = (url: string): boolean => {
  try {
    if (url.startsWith('data:image/')) {
      return true;
    }
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const getPlaceholderImage = (text: string = 'No Image'): string => {
  return `https://placehold.co/400x400/e2e8f0/64748b?text=${encodeURIComponent(text)}`;
};

export const compressImage = async (file: File): Promise<File> => {
  const options = {
    maxSizeMB: 20,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: file.type as 'image/jpeg' | 'image/png' | 'image/webp' | 'image/gif' | 'image/avif' | 'image/bmp'
  };

  try {
    return await imageCompression(file, options);
  } catch (error) {
    console.error('Image compression failed:', error);
    return file;
  }
};

export const validateImageFile = (file: File): boolean => {
  const ALLOWED_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/avif',
    'image/bmp'
  ];
  const MAX_SIZE = 20 * 1024 * 1024; // 20MB

  if (!ALLOWED_TYPES.includes(file.type)) {
    console.error('Invalid image type:', file.type);
    return false;
  }

  if (file.size > MAX_SIZE) {
    console.error('File too large:', file.size);
    return false;
  }

  return true;
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const preloadImage = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });
};